export const generateSchema = (breadcrumbs, baseUrl = 'https://blackroll.com') => {
  // Create the breadcrumb list schema
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((crumb, index) => {
      // Handle both string routes and route objects
      let path = '';
      if (typeof crumb.route === 'string') {
        // Direct string path (existing format)
        path = crumb.route;
      } else if (crumb.route && typeof crumb.route === 'object') {
        // Route object with path property (new format)
        path = crumb.route.path || '';
      }

      const itemUrl = path.startsWith('http') ? path : `${baseUrl}${path}`;

      return {
        '@type': 'ListItem',
        position: index + 1,
        name: crumb.label,
        item: itemUrl,
      };
    }),
  };

  return schema;
};
